import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { PUBLIC_BASE } from '../../pages/public/config';

const FALLBACK_IMG =
  'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg';

const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

function ArtistCard({ artist }) {
  const navigate = useNavigate();
  const genre = artist.genre || null;
  const isNew = artist.latestRelease
    && (Date.now() - new Date(artist.latestRelease).getTime()) < ONE_MONTH_MS;

  return (
    <div
      onClick={() => navigate(`${PUBLIC_BASE}/artists/${artist.id}`)}
      className="group cursor-pointer flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-white/5 transition-colors card-lift">
      {/* 원형 아티스트 사진 */}
      <div className="relative w-full aspect-square">
        {isNew && (
          <div
            className="absolute inset-0 rounded-full animate-spin shadow-[0_0_16px_rgba(236,72,153,0.5)]"
            style={{
              background: 'conic-gradient(from 0deg, #ec4899, #a855f7, #818cf8, #38bdf8, #ec4899)',
              animationDuration: '3s',
            }}
          />
        )}
        <div className={`absolute rounded-full overflow-hidden bg-[#182334] ${isNew ? 'inset-[2.5px]' : 'inset-0'}`}>
          {artist.image ? (
            <img
              src={artist.image}
              alt={artist.nameKr}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-800">
              <User size={32} className="text-slate-500" />
            </div>
          )}
        </div>
        {isNew && (
          <span className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[45%] bg-gradient-to-r from-pink-500 to-fuchsia-500 text-white text-[8px] font-bold px-2 py-[3px] rounded-full shadow-md leading-none whitespace-nowrap z-10">
            최근발매
          </span>
        )}
      </div>
      {/* 아티스트 이름 */}
      <p className="text-sm text-slate-300 group-hover:text-white transition-colors text-center truncate w-full leading-tight mt-2">
        {artist.nameKr}
      </p>
      {/* 장르 */}
      {genre && (
        <p className="text-[11px] text-slate-500 text-center truncate w-full leading-none">
          {genre}
        </p>
      )}
    </div>
  );
}

export default ArtistCard;
